// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subTargetCard {
  background-color: #f5f5f5;
}


.indicator-card-body-inputs {
  background-color: #fff;
  border-radius:  var(--chakra-radii-md);
  border: 1px solid #e2e8f0;
} 

`, "",{"version":3,"sources":["webpack://./src/assets/css/targets/targets.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,yBAAyB;AAC3B","sourcesContent":[".subTargetCard {\n  background-color: #f5f5f5;\n}\n\n\n.indicator-card-body-inputs {\n  background-color: #fff;\n  border-radius:  var(--chakra-radii-md);\n  border: 1px solid #e2e8f0;\n} \n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
